exports.dateformat = (value, type) => {
  //时间格式化
  if (value && value.length > 8 && type) {
    let newval = value.substring(0, 8)
    var pattern = /(\d{4})(\d{2})(\d{2})/;
    var formatedDate = newval.replace(pattern, '$1-$2-$3');
    let sswval = value.substring(8, 14)
    var sspattern = /(\d{2})(\d{2})(\d{2})/;
    var ssformatedDate = sswval.replace(sspattern, '$1:$2:$3');
    return formatedDate + " " + ssformatedDate
  } else if (value && value.length >= 8 && value) {
    let newval = value.substring(0, 8)
    var pattern = /(\d{4})(\d{2})(\d{2})/;
    var formatedDate = newval.replace(pattern, '$1-$2-$3');
    return formatedDate;

  } else if (value && value.length <= 6) {
    let newval = value.substring(0, 6)
    var pattern = /(\d{4})(\d{2})/;
    var formatedDate = newval.replace(pattern, '$1-$2');
    return formatedDate;
  }

};


exports.dateformat1 = (value, type) => {
  //时间格式化
  if (value && value.length > 8 && type) {
    let newval = value.substring(0, 8)
    var pattern = /(\d{4})(\d{2})(\d{2})/;
    var formatedDate = newval.replace(pattern, '$1/$2/$3');
    let sswval = value.substring(8, 14)
    var sspattern = /(\d{2})(\d{2})(\d{2})/;
    var ssformatedDate = sswval.replace(sspattern, '$1:$2:$3');
    return formatedDate + " " + ssformatedDate
  } else if (value && value.length >= 8 && value) {
    let newval = value.substring(0, 8)
    var pattern = /(\d{4})(\d{2})(\d{2})/;
    var formatedDate = newval.replace(pattern, '$1/$2/$3');
    return formatedDate;

  } else if (value && value.length <= 6) {
    let newval = value.substring(0, 6)
    var pattern = /(\d{4})(\d{2})/;
    var formatedDate = newval.replace(pattern, '$1/$2');
    return formatedDate;
  }

};
/**
 * 将日期格式化成格式(yyyy-MM-dd)的字符串
 * @param date 要格式化的日期，不传时默认当前时间，也可以是一个时间戳
 * @returns 返回格式化后的日期字符串
 */
exports.formatDate = (date, type) => {
  date = date == undefined ? new Date() : date;
  date = typeof date == 'number' ? new Date(date) : date;
  var y = date.getFullYear(); // 年份，注意必须用getFullYear
  var m = date.getMonth() + 1; // 月份，注意是从0-11
  var d = date.getDate(); // 日期
  var h = date.getHours();
  var mi = date.getMinutes();
  var s = date.getSeconds();
  m = m < 10 ? '0' + m : m;
  d = d < 10 ? '0' + d : d;
  h = h < 10 ? '0' + h : h;
  mi = mi < 10 ? '0' + mi : mi;
  s = s < 10 ? '0' + s : s;
  if ("1" == type) {
    return y + "" + m + "" + d;
  }
  if ("2" == type) {
    return y + '-' + m + '-' + d + " " + h + ":" + mi + ":" + s;
  }
  return y + '-' + m + '-' + d;
}

//格式化金额
exports.numformat = (number) => {
  if (number) {
    number = number.toString().replace(/\,/g, "");
    if (isNaN(number) || number == "") return "";
    number = Math.round(number * 100) / 100;
    if (number < 0)
      return '-' + outputdollars(Math.floor(Math.abs(number) - 0) + '') + outputcents(Math.abs(number) - 0);
    else
      return outputdollars(Math.floor(number - 0) + '') + outputcents(number - 0);
  } else if (number === 0) {
    return '0.00'
  }

};
// 金额格式化 不4舍五入
var moneyFormat = function (value) { // 金额 格式化
  if (!value && value !== 0) return '-';
  var intPart = Number(value) | 0; //获取整数部分
  var intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,'); //将整数部分逢三一断

  var floatPart = ".00"; //预定义小数部分
  var value2Array = value.toString().split(".");

  //=2表示数据有小数位
  if (value2Array.length == 2) {
    floatPart = value2Array[1].toString(); //拿到小数部分

    if (floatPart.length == 1) { //补0,实际上用不着
      return intPartFormat + "." + floatPart + '0';
    } else {
      return intPartFormat + "." + floatPart;
    }
  } else {
    return intPartFormat + floatPart;
  }
}
exports.money_format = (n) => {
    if(!n) return n;
    n = moneyFormat(n)
    let str = n.split('.');
    let re = /\d{1,3}(?=(\d{3})+$)/g;
    let n1 = str[0].replace(re, "$&,");
    let nu = str[1]
    if(parseInt(nu)<10){
      nu = "0"+ nu
    } else {

    }
    return str.length > 1 && str[1] ? `${n1}.${str[1]}` : `${n1}.00`;
}

//数字格式化
exports.number_format = (number, decimals, dec_point, thousands_sep) => {

  /*
   * 参数说明：
   * number：要格式化的数字
   * decimals：保留几位小数
   * dec_point：小数点符号
   * thousands_sep：千分位符号
   * */
  number = (number + '').replace(/[^0-9+-Ee.]/g, '');
  var n = !isFinite(+number) ? 0 : +number,
    prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
    sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
    dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
    s = '',
    toFixedFix = function (n, prec) {
      var k = Math.pow(10, prec);
      return '' + Math.ceil(n * k) / k;
    };
  s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
  var re = /(-?\d+)(\d{3})/;
  while (re.test(s[0])) {
    s[0] = s[0].replace(re, "$1" + sep + "$2");

  }
  if ((s[1] || '').length < prec) {
    s[1] = s[1] || '';
    s[1] += new Array(prec - s[1].length + 1).join('0');
  }
  return s.join(dec);

}
exports.formatCurrency = function(num) {
  num = num.toString().replace(/\$|\,/g,'');
  if(isNaN(num))
      num = "0";
  sign = (num == (num = Math.abs(num)));
  num = Math.floor(num*100+0.50000000001);
  cents = num%100;
  num = Math.floor(num/100).toString();
  if(cents<10)
  cents = "0" + cents;
  for (var i = 0; i < Math.floor((num.length-(1+i))/3); i++)
  num = num.substring(0,num.length-(4*i+3))+','+
  num.substring(num.length-(4*i+3));
  return (((sign)?'':'-') + num + '.' + cents);
}

//还原格式化
exports.restoreformat = (number) => {
  if (number) {
    number = number.toString().replace(/\,/g, "");
    if (number.indexOf(".00") != "-1") {
      return number.substring(0, number.length - 3)
    }
    return number;
  } else {
    return ""
  }

};

//判断导出数据长度
exports.exportLength = (total) => {
  if (total > 5000) {
    return true
  }

}

//格式化金额
function outputdollars(number) {
  if (number.length <= 3)
    return (number == '' ? '0' : number);
  else {
    var mod = number.length % 3;
    var output = (mod == 0 ? '' : (number.substring(0, mod)));
    for (i = 0; i < Math.floor(number.length / 3); i++) {
      if ((mod == 0) && (i == 0))
        output += number.substring(mod + 3 * i, mod + 3 * i + 3);
      else
        output += ',' + number.substring(mod + 3 * i, mod + 3 * i + 3);
    }
    return (output);
  }
}

function outputcents(amount) {
  amount = Math.round(((amount) - Math.floor(amount)) * 100);
  return (amount < 10 ? '.0' + amount : '.' + amount);
}



// WEBPACK FOOTER //
// ./src/common/js/filter/filter.js